import { AuthDataModel } from '@core/models/auth-data.model';

export function readStoredAuthData(): AuthDataModel | null {
  const stored = localStorage.getItem('userDetails');
  if (!stored) {
    return null;
  }

  try {
    const parsed = JSON.parse(stored) as AuthDataModel;
    if (parsed.expiry && Date.now() > parsed.expiry) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function getStoredAccessToken(): string | null {
  return readStoredAuthData()?.access_token ?? null;
}

export function hasStoredAuthToken(): boolean {
  return !!getStoredAccessToken();
}
